export default __webpack_public_path__ + "static/media/nodeJsImage.b575aea7.png";